import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { CollectionPaths } from '@models/collections';
import { Repo } from '../repo.service';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { BusinessState } from '@state/business';
import { BusinessBaseDocx } from '@models/businesses';

@Injectable({
	providedIn: 'root',
})
export class BusinessBaseDocxRepo extends Repo<BusinessBaseDocx, null> {
	@SelectSnapshot(BusinessState.businessId) businessId: string;

	constructor(private firestore: AngularFirestore) {
		super(firestore);
	}

	GetCollectionPath(): string {
		return CollectionPaths.business_base_docxs(this.businessId);
	}
}
